import polz from "../../../assets/images/polzovatel.svg";
import org from "../../../assets/images/org.svg";
import zayavki from "../../../assets/images/Zayavki.svg";
import contacts from "../../../assets/images/contacts.svg";
import tender from "../../../assets/images/tender.svg";
import pk from "../../../assets/images/platejniykalendar.svg";
import products from "../../../assets/images/products.svg";
import post from "../../../assets/images/postavshiki.svg";
import objects from "../../../assets/images/obyektiy.svg";
import smeta from "../../../assets/images/smeta.svg";
import sklad from "../../../assets/images/sklad.svg";
import otch from "../../../assets/images/otchet.svg";
import news from "../../../assets/nodes/new.svg";
import received from "../../../assets/nodes/received.svg";
import confirmed from "../../../assets/nodes/confirmed.svg";
import saved from "../../../assets/nodes/saved.svg";
import confirmSZK from "../../../assets/nodes/podSzk.svg";
import myContracts from "../../../assets/nodes/mycontracts.svg";
import rejected from "../../../assets/nodes/rejected.svg";
import operating from "../../../assets/nodes/operating.svg";
import resp from "../../../assets/images/responsible.svg";
import wallet from "../../../assets/images/wallet.svg";
import revision from "../../../assets/images/refresh.png";
// import byContracts from '../../../assets/nodes/byContracts.svg';
// import byRequest from '../../../assets/nodes/byRequest.svg'
import nastroyki from "../../../assets/images/settingsBlue.svg";
import access from "../../../assets/nodes/access.svg";
import dostup from "../../../assets/nodes/dostup.svg";
import role from "../../../assets/nodes/role.svg";
import type from "../../../assets/images/typeGreen.svg";

export const SideData = [
  {
    name: {
      uz: "Foydalanuvchilar",
      en: "Users",
      ru: "Пользователи",
    },
    img: polz,
    link: "ui/users/all",
    active: "ui/users/all",
    nodes: [
      {
        name: {
          uz: "Barcha",
          en: "All",
          ru: "Все",
        },
        img: saved,
        link: "ui/users/all",
        badge: null,
        accessPermission: "",
        count: "",
      },
      {
        name: {
          uz: "Lavozim",
          en: "position",
          ru: "Должгость",
        },
        img: type,
        link: "ui/users/position",
        badge: null,
        accessPermission: "POSITION_TYPE_VIEW",
        count: "",
      },
    ],
    accessPermission: "USER_VIEW",
  },
  {
    name: {
      uz: "Tashkilotlar",
      en: "Organizations",
      ru: "Организации",
    },
    img: org,
    link: "ui/org/all",
    active: "/ui/org/all",
    nodes: [],
    accessPermission: "ORGANIZATION_VIEW",
  },
  {
    name: {
      uz: "Arizalar",
      en: "Applications",
      ru: "Заявки",
    },
    img: zayavki,
    link: "ui/application/new",
    active: "/ui/apl",
    nodes: [
      {
        name: {
          uz: "Yangi",
          en: "New",
          ru: "Новая",
        },
        img: news,
        link: "ui/application/new",
        badge: null,
        accessPermission: "APPLICATION_CREATE",
        count: "",
      },
      {
        name: {
          uz: "Barcha arizalar",
          en: "All application",
          ru: "Все",
        },
        img: saved,
        link: "ui/application/all",
        badge: 18500,
        accessPermission: "",
        count: "allApplicationCount",
      },
      {
        name: {
          uz: "Qabul qilingan",
          en: "Received",
          ru: "Принятые",
        },
        img: received,
        link: "ui/application/receive",
        badge: 18500,
        accessPermission: "",
        count: "receivedApplicationCount",
      },
      {
        name: {
          uz: "SZK tasdiqlagan",
          en: "Confirmed by SZK",
          ru: "Подтверж. От ЦЗК",
        },
        img: confirmSZK,
        link: "ui/application/cpc",
        badge: 18500,
        accessPermission: "",
        count: "confirmedBySnabApplicationCount",
      },
      {
        name: {
          uz: "Tasdiqlangan",
          en: "Confirmed",
          ru: "Подтвержденные",
        },
        img: confirmed,
        link: "ui/application/confirmed",
        badge: 854,
        accessPermission: "",
        count: "confirmedApplicationCount",
      },
      {
        name: {
          uz: "Mening arizalarim",
          en: "My applications",
          ru: "Я автор",
        },
        img: myContracts,
        link: "ui/application/my",
        badge: 8514,
        accessPermission: "",
        count: "myApplicationCount",
      },
      {
        name: {
          uz: "Men javobgar arizalar",
          en: "My responsible applications",
          ru: "Я исполнитель",
        },
        img: resp,
        link: "ui/application/res",
        badge: 8514,
        accessPermission: "",
        count: "resApplicationCount",
      },
    ],
    accessPermission: "APPLICATION_VIEW",
  },
  {
    name: {
      uz: "Shartnomalar",
      en: "Contracts",
      ru: "Контракты",
    },
    img: contacts,
    link: "ui/",
    active: "",
    nodes: [
      {
        name: {
          uz: "Barcha shartnomalar",
          en: "All contracts",
          ru: "Все",
        },
        img: saved,
        link: "ui/contracts/all",
        badge: 1254,
        accessPermission: "",
        count: "allContractCount",
      },
      {
        name: {
          uz: "Qabul qilingan",
          en: "Received",
          ru: "Принятые",
        },
        img: received,
        link: "ui/contracts/accepted",
        badge: 1254,
        accessPermission: "",
        count: "receivedContractCount",
      },
      {
        name: {
          uz: "20 milliongacha",
          en: "Up to 20 million",
          ru: "До 20 миллионов",
        },
        img: wallet,
        link: "ui/contracts/to20",
        badge: 8514,
        accessPermission: "",
        count: "to20ContractCount",
      },
      {
        name: {
          uz: "Men javobgar kontaktlar",
          en: "My responsible contracts",
          ru: "Я исполнитель",
        },
        img: resp,
        link: "ui/contracts/res",
        badge: 8514,
        accessPermission: "",
        count: "resContractCount",
      },
      {
        name: {
          uz: "Mening kontraktlarim",
          en: "My contracts",
          ru: "Я автор",
        },
        img: myContracts,
        link: "ui/contracts/my",
        badge: 8514,
        accessPermission: "",
        count: "myContractCount",
      },
      {
        name: {
          uz: "SZK tasdiqlagan",
          en: "Confirmed by CZK",
          ru: "Подтверж. От ЦЗК",
        },
        img: confirmSZK,
        link: "ui/contracts/cpc",
        badge: 854,
        accessPermission: "",
        count: "confirmedBySnabContractCount",
      },
      {
        name: {
          uz: "Tasdiqlangan",
          en: "Confirmed",
          ru: "Подтвержденные",
        },
        img: confirmed,
        link: "ui/contracts/confirmed",
        badge: 18500,
        accessPermission: "",
        count: "confirmedContractCount",
      },
      {
        name: {
          uz: "Qayta ko'rib chiqariladigan",
          en: "Revision",
          ru: "Доработка",
        },
        img: revision,
        link: "ui/contracts/revision",
        badge: 8514,
        accessPermission: "",
        count: "revisionContractCount",
      },
      {
        name: {
          uz: "Rad etilgan",
          en: "Rejected",
          ru: "Отклонено",
        },
        img: rejected,
        link: "ui/contracts/rejected",
        badge: 8514,
        accessPermission: "",
        count: "rejectedContractCount",
      },
    ],
    accessPermission: "CONTRACT_VIEW",
  },
  {
    name: {
      uz: "Tekshirilgan kontragentlar",
      en: "Verified counterparties",
      ru: "Провереные контрагенты",
    },
    img: org,
    link: "ui/verified/all",
    active: "/ui/verified/all",
    nodes: [],
    accessPermission: "CHECKED_SUPPLIER_VIEW",
  },
  {
    name: {
      uz: "Tender",
      en: "Tender",
      ru: "Тендер",
    },
    img: tender,
    link: "ui/tender/active",
    active: "",
    nodes: [
      {
        name: {
          uz: "Amaldagi",
          en: "Confirmed",
          ru: "Действующие",
        },
        img: operating,
        link: "ui/tender/active",
        badge: 4525,
        accessPermission: "",
        count: "actingTenderCount",
      },
      {
        name: {
          uz: "Tasdiqlangan",
          en: "Confirmed",
          ru: "Подтвержденные",
        },
        img: confirmed,
        link: "ui/tender/confirmed",
        badge: 8514,
        accessPermission: "",
        count: "confirmedTenderCount",
      },
    ],
    accessPermission: "TENDER_VIEW",
  },
  {
    name: {
      uz: "To'lov jadvali",
      en: "Payment schedule",
      ru: "Платежный календарь",
    },
    img: pk,
    link: "ui/payment/all",
    active: "/ui/payment/all",
    nodes: [],
    accessPermission: "PAYMENT_CALENDAR_VIEW",
  },
  {
    name: {
      uz: "Mahsulotlar",
      en: "products",
      ru: "Продукты",
    },
    img: products,
    link: "ui/products/all",
    active: "",
    nodes: [
      {
        name: {
          uz: "Tasdiqlangan",
          en: "Confirmed",
          ru: "Продукты",
        },
        img: confirmed,
        link: "ui/products/all",
        badge: null,
        accessPermission: "PRODUCT_VIEW",
      },
      {
        name: {
          uz: "Amaldagi",
          en: "Confirmed",
          ru: "Категория",
        },
        img: operating,
        link: "ui/products/category",
        badge: null,
        accessPermission: "PRODUCT_CATEGORY_VIEW",
      },
    ],
    accessPermission: "PRODUCT_ALL_VIEW",
  },
  {
    name: {
      uz: "Yetkazib beruvchilar",
      en: "Suppliers",
      ru: "Поставщики",
    },
    img: post,
    link: "ui/suppliers/all",
    active: "/ui/suppliers/all",
    nodes: [],
    accessPermission: "SUPPLIER_VIEW",
    // CHECKED_SUPPLIER_VIEW
  },
  {
    name: {
      uz: "Ob'ektlar",
      en: "Objects",
      ru: "Объекты",
    },
    img: objects,
    link: "ui/objects/all",
    active: "",
    nodes: [
      {
        name: {
          uz: "Ob'ektlar",
          en: "Objects",
          ru: "Объекты",
        },
        img: confirmed,
        link: "ui/objects/all",
        badge: null,
        accessPermission: "OBJECT_VIEW",
      },
      {
        name: {
          uz: "Kategoriya",
          en: "Category",
          ru: "Категория",
        },
        img: operating,
        link: "ui/objects/types",
        badge: null,
        accessPermission: "OBJECT_CATEGORY_VIEW",
      },
    ],
    accessPermission: "OBJECT_ALL_VIEW",
  },
  {
    name: {
      uz: "Smeta",
      en: "Estimate",
      ru: "Смета",
    },
    img: smeta,
    link: "ui/",
    active: "",
    nodes: [],
    accessPermission: "ESTIMATE_VIEW",
  },
  {
    name: {
      uz: "Ombor",
      en: "Warehouse",
      ru: "Склад",
    },
    img: sklad,
    link: "ui/warehouse/all",
    active: "/ui/warehouse/all",
    nodes: [],
    accessPermission: "WAREHOUSE_VIEW",
  },
  {
    name: {
      uz: "Hisobotlar",
      en: "Reports",
      ru: "Отчеты",
    },
    img: otch,
    link: "ui/",
    active: "",
    nodes: [
      {
        name: {
          uz: "Shartnomalar bo'yicha",
          en: "By contracts",
          ru: "По контрактам",
        },
        img: confirmed,
        link: "ui/reportsby/contract",
        badge: null,
        accessPermission: "",
      },
      {
        name: {
          uz: "Arizalar bo'yicha",
          en: "By Applications",
          ru: "По заявкам",
        },
        img: saved,
        link: "ui/reportsby/applications",
        badge: null,
        accessPermission: "",
      },
      // {
      //    name: {
      //       uz: "Mahsulotlar bo'yicha",
      //       en: "By Products",
      //       ru: "По Продуктам"
      //    },
      //    img: products,
      //    link: "ui/by/products",
      //    badge: null,
      //    accessPermission: ""
      // }
    ],
    accessPermission: "REPORT_VIEW",
  },
  {
    name: {
      uz: "Sozlamalar",
      en: "Settings",
      ru: "Settings",
    },
    img: nastroyki,
    link: "ui/settings/type",
    active: "/ui/settings",
    nodes: [
      {
        name: {
          uz: "Turlari",
          en: "Types",
          ru: "Типы",
        },
        img: type,
        link: "ui/settings/type",
        badge: null,
        accessPermission: "",
      },
      {
        name: {
          uz: "Rollar",
          en: "Roles",
          ru: "Роли",
        },
        img: role,
        link: "ui/settings/roles",
        badge: null,
        accessPermission: "",
      },
      {
        name: {
          uz: "Ruxsat",
          en: "Resolution",
          ru: "Разрешение",
        },
        img: access,
        link: "ui/settings/access",
        badge: null,
        accessPermission: "",
      },
      {
        name: {
          uz: "Ruxsat",
          en: "Access",
          ru: "Доступ",
        },
        img: dostup,
        link: "ui/settings/resolution",
        badge: null,
        accessPermission: "",
      },
      {
        name: {
          uz: "Telegram",
          en: "Telegram",
          ru: "Телеграм",
        },
        img: dostup,
        link: "ui/settings/telegram",
        activeParent: "/ui/telegram",
        badge: null,
        accessPermission: "",
      },
    ],
    accessPermission: "SETTING_VIEW",
  },
];
